"use strict";

var _interopRequireDefault = require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/createClass.js"));
var _Photo = _interopRequireDefault(require("./Photo"));
var _Clip = _interopRequireDefault(require("./Clip"));
var Cropper = /*#__PURE__*/function () {
  function Cropper(width, height) {
    (0, _classCallCheck2["default"])(this, Cropper);
    // view port dimension
    this.width = width;
    this.height = height;
  }
  return (0, _createClass2["default"])(Cropper, [{
    key: "setPhoto",
    value: function setPhoto(width, height, scale) {
      // assign the new width and height
      var newHeight = this.clip.height;
      var newWidth = this.clip.width;
      // calculate ratio
      var clipRatio = this.clip.width / this.clip.height;
      var photoRatio = width / height;
      // adjust size base on ratio
      if (clipRatio > photoRatio) {
        newHeight = height * (newWidth / width);
      } else {
        newWidth = width * (newHeight / height);
      }
      // center
      var x = (this.width - newWidth) * .5;
      var y = (this.height - newHeight) * .5;
      this.photo = new _Photo["default"](x, y, newWidth, newHeight, scale);
    }
  }, {
    key: "setCLip",
    value: function setCLip(width, height) {
      var x = this.width / 2 - width / 2;
      var y = this.height / 2 - height / 2;
      this.clip = new _Clip["default"](x, y, width, height);
    }
  }, {
    key: "movePhoto",
    value: function movePhoto(x, y) {
      this.photo.x = x;
      this.photo.y = y;
      // set limit
      this.positionPhoto();
    }
  }, {
    key: "scalePhoto",
    value: function scalePhoto(scale) {
      var lastWidth = this.photo.getWidth();
      var lastHeight = this.photo.getHeight();
      var currentWidth = this.photo.width * scale;
      var currentHeight = this.photo.height * scale;
      // minimum size
      if (currentWidth < this.clip.width) return;
      if (currentHeight < this.clip.height) return;
      var deltaWidth = currentWidth - lastWidth;
      var deltaHeight = currentHeight - lastHeight;
      var x = this.photo.x - deltaWidth / 2;
      var y = this.photo.y - deltaHeight / 2;
      this.photo.setScale(scale);
      this.photo.x = x;
      this.photo.y = y;
      this.positionPhoto();
    }
  }, {
    key: "positionPhoto",
    value: function positionPhoto() {
      if (this.photo.x >= this.clip.x) {
        // left
        this.photo.x = this.clip.x;
      }
      if (this.photo.x + this.photo.getWidth() <= this.clip.x + this.clip.width) {
        // right
        this.photo.x = this.clip.x + this.clip.width - this.photo.getWidth();
      }
      if (this.photo.y >= this.clip.y) {
        // top
        this.photo.y = this.clip.y;
      }
      if (this.photo.y + this.photo.getHeight() <= this.clip.y + this.clip.height) {
        // down
        this.photo.y = this.clip.y + this.clip.height - this.photo.getHeight();
      }
    }
  }]);
}();
var _default = exports["default"] = Cropper;